class PlanDayLimit {
  constructor(private readonly value: number = NaN) {
  }

  public isEmpty() {
    return isNaN(this.value);
  }

  public toString(): string {
    return this.isEmpty() ? "" : String(this.value);
  }

  public toNumber(): number {
    return this.value;
  }
}

export default PlanDayLimit;
